import { LoadingIcon } from '@/components/icons/loading'
import { StatusMessage } from '@/components/shared/statusMessage'

export const TxLoader = ({ className }: { className?: string }) => {
  return (
    <StatusMessage className={className}>
      <LoadingIcon className="mx-auto animate-spin text-accent" />
      <h6>Confirm transaction in wallet</h6>
      <p>A modal should appear on the screen in which you need to confirm the transaction.</p>
    </StatusMessage>
  )
}
